// Small shared pieces of the storyline pages (the identity mocks,
// 2026-11-01): dates, the side colours and the coverage label.

import { coverageDisplayText, coverageFromCounts } from '@/utils/bias'

// "Oct 31", from a YYYY-MM-DD Eastern day key.
export function shortDate(day) {
  if (!day) return ''
  const d = new Date(`${String(day).slice(0, 10)}T12:00:00Z`)
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

// "August 19, 2026".
export function longDate(day) {
  if (!day) return ''
  const d = new Date(`${String(day).slice(0, 10)}T12:00:00Z`)
  return d.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

export function daysBetween(a, b) {
  return Math.round(
    (new Date(`${b}T12:00:00Z`) - new Date(`${a}T12:00:00Z`)) / 86400000
  )
}

export const WINGS = ['left', 'center', 'right']

// The lean colours, through Tailwind's re-cut blue/red/zinc (never raw
// hexes): text for counts and labels, bg for bars and swatches.
export const SIDE = {
  left: {
    label: 'Left',
    text: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-600',
    border: 'border-blue-600',
  },
  center: {
    label: 'Center',
    text: 'text-muted-foreground',
    bg: 'bg-zinc-500',
    border: 'border-zinc-500',
  },
  right: {
    label: 'Right',
    text: 'text-red-600 dark:text-red-400',
    bg: 'bg-red-600',
    border: 'border-red-600',
  },
}

export const totalOf = (counts) =>
  WINGS.reduce((n, w) => n + (counts?.[w] || 0), 0)

// Pano's label for a set of counts ("Balanced", "Leans Right"...), or null
// when there is nothing to rate.
export function labelOf(counts) {
  const { key, text } = coverageFromCounts(
    counts?.left || 0,
    counts?.center || 0,
    counts?.right || 0
  )
  if (key === 'none') return null
  return { key, text: coverageDisplayText(text) }
}

// Which way a label points, for comparing a day to the whole.
export function sideOfKey(key) {
  if (key === 'left' || key === 'leans_left') return 'left'
  if (key === 'right' || key === 'leans_right') return 'right'
  return null
}

export const ariaCounts = (counts) =>
  `${counts.left || 0} left, ${counts.center || 0} center, ${counts.right || 0} right`
